<template>
  <v-dialog v-model="show" max-width="800" scrollable>
    <template v-slot:activator="{on}">
      <slot name="activator" :on="on"></slot>
    </template>
    <v-card :loading="loading" :disabled="loading">
      <v-card-actions>
        <div class="title">Guides({{$router.currentRoute.name}})</div>
        <v-spacer></v-spacer>
        <v-btn @click="show = !show" icon><v-icon>close</v-icon></v-btn>
      </v-card-actions>
      <v-divider></v-divider>
      <v-card-text class="pa-0">
        <v-text-field v-model="search" label="Search (tags/titles)" filled></v-text-field>
        <v-expansion-panels v-if="guides && guides.length > 0">
          <template v-for="(guide, index) in searchGuides">
            <v-expansion-panel :key="index">
              <v-expansion-panel-header>
                <v-list-item three-line>
                  <v-list-item-content>
                    <v-list-item-title class="">{{guide.title}}</v-list-item-title>
                    <v-list-item-subtitle>{{guide.description}}</v-list-item-subtitle>
                    <template  v-if="guide.tags" >
                      <v-list-item-subtitle ><v-chip v-for="tag in guide.tags" :key="tag" small label>{{tag}}</v-chip></v-list-item-subtitle>
                    </template>
                    <v-list-item-subtitle v-else label small><v-chip >No tags applied to this guide</v-chip></v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <GuideViewNoDialog :guide="guide" no_title></GuideViewNoDialog>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </template>
        </v-expansion-panels>
        <v-alert v-else-if="guides && guides.length < 1" type="info" color="secondary" tile>No guides have been created for this area.</v-alert>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "help",
  components: {
    GuideViewNoDialog: () => import("./GuideViewNoDialog")
  },
  data: () => ({
    show: false,
    loading: false,
    guides: null,
    search: null,
  }),
  watch:{
    show(v){
      if(v && !this.loading){
        this.getGuides();
      }
    }
  },
  computed: {
    searchGuides(){
      if(this.search){
        let searchLower = this.search.toLowerCase();
        return this.guides.filter(guide => (guide.tags && guide.tags.some(tag => tag.toLowerCase().includes(searchLower))) || guide.title.toLowerCase().includes(searchLower))
      }
      return this.guides
    }
  },
  mounted(){
    this.getGuides();
  },
  methods: {
    async getGuides(){
      this.loading = true;
      let guides = await this.$firestore.collection('guides').where('tags', 'array-contains-any', [this.$router.currentRoute.name, this.$router.currentRoute.name.toLowerCase(), 'all']).get();
      this.guides = guides.docs.map(guide => guide.data());
      this.loading = false;
    }
  }
}
</script>

<style scoped>

</style>
